<div class="offer-card" [class.expanded]="isExpanded">
  <div class="offer-card-header">
    <div class="offer-card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M13.2046 17.7051C13.6439 17.2658 14.3561 17.2658 14.7954 17.7051L19.0454 21.9551C19.4848 22.3944 19.4847 23.1066 19.0454 23.5459C18.6061 23.9852 17.8939 23.9852 17.4546 23.5459L13.2046 19.2959C12.7653 18.8566 12.7653 18.1444 13.2046 17.7051Z" fill="#F79D00"/>
        <path d="M9.97999 9.98048C10.4681 9.49233 11.2599 9.49233 11.7481 9.98048C12.2362 10.4686 12.2362 11.2604 11.7481 11.7485C11.2599 12.2367 10.4681 12.2367 9.97999 11.7485C9.49183 11.2604 9.49183 10.4686 9.97999 9.98048Z" fill="#F79D00"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0274 4.79005C15.1788 4.63813 16.3414 5.02811 17.169 5.85548L26.9507 15.6372C28.4152 17.1017 28.4152 19.4765 26.9507 20.9409L20.9404 26.9512C19.476 28.4156 17.1012 28.4156 15.6367 26.9512L5.85499 17.1694C4.9725 16.2868 4.58703 15.0228 4.82667 13.7979L5.81055 8.77101C6.1035 7.27431 7.27382 6.104 8.77051 5.81105L13.7974 4.82716L14.0274 4.79005ZM15.5781 7.44679C15.2251 7.09386 14.7194 6.93937 14.2295 7.03517L9.20264 8.01856C8.60391 8.13573 8.13524 8.6044 8.01807 9.20314L7.03468 14.23C6.94484 14.6894 7.07524 15.1625 7.38282 15.5108L7.4463 15.5786L17.228 25.3604L17.2837 25.4131C17.8535 25.928 18.7236 25.928 19.2935 25.4131L19.3491 25.3604L25.3599 19.3496C25.9454 18.7639 25.9455 17.8143 25.3599 17.2285L15.5781 7.44679Z" fill="#F79D00"/>
      </svg>
    </div>
    <div
      class="offer-header"
      (click)="showMore && onShowMore()"
      [class.disabled]="!showMore"
      [attr.role]="showMore ? 'button' : null"
      [attr.tabindex]="showMore ? '0' : null"
      [attr.aria-expanded]="showMore ? isExpanded : null"
    >
      <span class="offer-title">{{ offer }}</span>

      <!-- Hide chevron unless expandable -->
      <i *ngIf="showMore" class="bi bi-chevron-down chevron" [class.rotate]="isExpanded"></i>
    </div>
  </div>

  <div *ngIf="isExpanded" class="offer-body">
    Check your
    <a class="offer-fake-link" (click)="openAdoptionPacket()">Adoption Packet</a>
    or contact this business to confirm the offer.
  </div>
</div>
